var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{staticStyle:{"height":"auto"}},[_c('p',[_vm._v("Card content")]),_c('p',[_vm._v("Card content")]),_c('p',[_vm._v("Card content")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }